import {Injectable} from '@angular/core';
import {Intercom} from 'ng-intercom';
import {environment} from '../../../environments/environment';
import {getFullName} from '@q9elements/ui-kit/common';

@Injectable({
  providedIn: 'root'
})
export class Q9IntercomService {
  booted = false;

  constructor(private intercom: Intercom) {}

  bootIntercom(user) {
    if (this.booted) {
      return;
    }

    this.booted = true;
    const intercomOptions: any = {
      app_id: environment.INTERCOM_APP_ID,
      user_id: user.id,
      email: user.email,
      name: getFullName(user),
      created_at: new Date(user.createdAt).getTime() / 1000,
      widget: {activator: '#intercom'},
      alignment: 'left',
      user_hash: user.intercomToken,
      private: environment.CLOUD_TYPE === 'private' ? environment.CLOUD_NAME : null,
      public: environment.CLOUD_TYPE === 'public' ? 'yes' : null
    };

    if (user.userInTeam && user.userInTeam.team) {
      intercomOptions.team = user.userInTeam.team.name;
      intercomOptions.teamId = user.userInTeam.team._id.toString();
    }

    this.intercom.boot(intercomOptions);
  }

  showNewMessage(msg: string = '') {
    this.intercom.showNewMessage(msg);
  }

  fireEvent(eventType: string, eventName: string = '', metadata: any = {}) {
    switch (eventType) {
      case 'ACTION':
        this.intercom.trackEvent(eventName, metadata);
        break;

      case 'DESTROY':
        this.intercom.shutdown();
    }
  }
}
